import axios from "axios";
import store from "../store";
import router from "../router";
import { Loading } from "element-ui";
import { Toast } from "vant";
import Vue from "vue";
import { isMobile } from "../utils/isMobile";
// 创建axios实例

const service = axios.create({
  // baseURL: "https://setonapi.wsandos.com/",
  baseURL: "https://xdzsht.cdn.cc/", // api 的 VUE_APP_URL  process.env.VUE_APP_URL
  timeout: 10000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
  token: "",
});

/** 定义默认配置 */
// service.defaults.baseURL = '/api';
// service.defaults.header = 'Access-Control-Allow-Origin';
service.defaults.headers = {
  "Content-Type": "application/json;charset=UTF-8",
  token: "",
};
// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem('token');
    // if (store.state.userInfo) {
    //   const token = store.state.userInfo.token;
    //   // 给请求头添加laohu-token
    //   config.headers["token"] = token;
    // }
    // if (config.load) {
    if (!isMobile()) {
      // Loading.service({
      //   message: "数据加载中....",
      //   forbidClick: true,
      //   duration: false,
      // });
    } else {
      Toast.loading({
        message: "数据加载中....",
        forbidClick: true,
      });
    }

    // }
    return config;
  },
  (error) => {
    // Loading.clear();
    Promise.reject(error);
  }
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
  (response) => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code == 200) {
      // setTimeout(() => {
      //   Loading.clear();
      // }, 2000)
      return res;
    } else {
      switch (res.code) {
        case 400:
          if (!isMobile()) {
            // Loading(res.msg);
          } else {
            Toast(res.msg);
          }
          return Promise.reject(res.msg);
          break;
        default:
          return Promise.reject(res.msg);
      }
      Promise.reject(res.msg);
    }
  },
  (err) => {
    // Loading.fail()
    if (err.response) {
      // Loading.clear()
      switch (err.response.status) {
        case 400:
          err.message = err.response.data.msg;
          console.log(err.message);
          if (!isMobile()) {
            // Loading(err.response.data.msg);
          } else {
            Toast(err.response.data.msg);
          }
          break;
        case 401:
          return Promise.reject(err.response.message);
          break;
        case 403:
          err.message = "拒绝访问";
          break;
        case 404:
          err.message = "请求错误,未找到该资源";
          break;
        case 405:
          err.message = "请求方法未允许";
          break;
        case 408:
          err.message = "请求超时";
          break;
        case 500:
          // Loading("服务器端出错");
          err.message = "服务器端出错";
          break;
        case 501:
          err.message = "网络未实现";
          break;
        case 502:
          err.message = "网络错误";
          break;
        case 503:
          err.message = "服务不可用";
          break;
        case 504:
          err.message = "网络超时";
          break;
        case 505:
          err.message = "http版本不支持该请求";
          break;
        default:
          err.message = `连接错误${err.response.status}`;
      }
    }
    // if (err.status!=200) {
    //   throw new Error('错误!, 加载并未实现!');
    // }
    setTimeout(() => {
      // Loading.clear();
    }, 500);
    console.log(err, "请求失败");
    return Promise.reject("请求失败");
  }
);
export default service;
